export default __webpack_public_path__ + "static/icon-accessories-77e74a5a2b3105080741800afe785f73.svg";